import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";

export default class TokenRequest implements IRequestBuilder {
    get method() {
      return "POST";
    }
  
    get path() {
      return Configs.game.clientConfig.tokenApi;
    }
  
    get requestData() {
      let props = {
        ticket: GameModel.urlParams.ticket,
        clientversion: GameModel.gameVersion,
        partnerid: GameModel.partnerid,
        channel: GameModel.urlParams.channel || "web",
        mode: GameModel.mode,
        gameref: Configs.vendorServer.gameId,
        clientid: GameModel.urlParams.clientid || "",
        currency: "",
      };
  
      ConsoleUtil.log("[SBRequests] Token request:", props);
  
      return props;
    }
  }